// Шаблоны сообщений для двуязычной системы
// Параметры в фигурных скобках будут заменяться реальными данными

export const messageTemplates = {
  bot_responses: {
    // Баланс и цены
    balance_info: {
      RUS: "💰<strong><u>БАЛАНС</u></strong><br><br><strong>{quote_currency}</strong><br>Доступно: {quote_free}<br>Заморожено: {quote_used}<br><br><strong>{coin}</strong><br>Доступно: {coin_free}<br>Заморожено: {coin_used}<br><br><strong>Ордера ({orders_count})</strong><br><u>Исполнение</u><br>На <u>{pending_amount} {quote_currency}</u> по средней <u>{avg_price} {quote_currency}</u>",
      ENG: "💰<strong><u>BALANCE</u></strong><br><br><strong>{quote_currency}</strong><br>Available: {quote_free}<br>Locked: {quote_used}<br><br><strong>{coin}</strong><br>Available: {coin_free}<br>Locked: {coin_used}<br><br><strong>Orders ({orders_count})</strong><br><u>In Execution</u><br>For <u>{pending_amount} {quote_currency}</u> at an average of <u>{avg_price} {quote_currency}</u>"
    },
    price_info: {
      RUS: "Текущая цена {coin} <strong>{price} {quote_currency}</strong>",
      ENG: "Current price {coin} <strong>{price} {quote_currency}</strong>"
    },

    // Статистика
    stats_info: {
      RUS: "📊 <strong><u>{period_display}</u></strong>\n\nКоличество сделок: <strong>{count}</strong>\nПрибыль: <strong>{profit} {currency}</strong>",
      ENG: "📊 <strong><u>{period_display}</u></strong>\n\nNumber of trades: <strong>{count}</strong>\nProfit: <strong>{profit} {currency}</strong>"
    },

    // Подписка
    subscription_active: {
      RUS: "🗓️ Подписка на бота действует до {formatted_date} <strong>(осталось {days_remaining} дней)</strong>.",
      ENG: "🗓️ Bot subscription is valid until {formatted_date} <strong>({days_remaining} days remaining)</strong>."
    },

    api_keys_invalid: {
      RUS: "❌ <strong><u>НЕКОРРЕКТНЫЕ API КЛЮЧИ</u></strong><br><br>Ваши API ключи некорректны, пожалуйста обновите API ключи во вкладке Управление аккаунтом.",
      ENG: "❌ <strong><u>INVALID API KEYS</u></strong><br><br>Your API keys are invalid, please update your API keys in the Account Management tab."
    },
    
    // Помощь
    help_info: {
      RUS: "Перейдите в раздел ⚙️<a class='help-link' onclick='window.navigateToInstructions()'><strong>Инструкции</strong></a>, чтобы ознакомиться с командами управления ботом и его настройками.<br/><br/>💬 Для связи со службой поддержки напишите <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' class='inline w-4 h-4 align-text-bottom mr-1' style='position:relative;top:-3px;'><circle cx='12' cy='12' r='12' fill='#229ED9'/><path d='M17.5 7.5L15.5 17.5C15.5 17.5 15.25 18 14.75 18C14.5 18 14.25 17.75 14 17.5L11.5 15.5L10.5 16.5C10.5 16.5 10.5 16.5 10.25 16.5C10 16.5 10 16.25 10 16.25L9.5 13.5L15.25 8.75C15.5 8.5 15.25 8.5 15 8.75L8.5 13L6.5 12.5C6.5 12.5 6 12.25 6 12C6 11.75 6.5 11.5 6.5 11.5L17 7.25C17.25 7.25 17.5 7.25 17.5 7.5Z' fill='#fff'/></svg><a href=\"https://t.me/ForsBotSupport\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-primary hover:underline font-medium\">@ForsBotSupport</a> в Telegram.",
      ENG: "Go to the ⚙️<a class='help-link' onclick='window.navigateToInstructions()'><strong>Instructions</strong></a> section to learn about bot management commands and settings.<br/><br/>💬 For support, write to <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' class='inline w-4 h-4 align-text-bottom mr-1' style='position:relative;top:-3px;'><circle cx='12' cy='12' r='12' fill='#229ED9'/><path d='M17.5 7.5L15.5 17.5C15.5 17.5 15.25 18 14.75 18C14.5 18 14.25 17.75 14 17.5L11.5 15.5L10.5 16.5C10.5 16.5 10.5 16.5 10.25 16.5C10 16.5 10 16.25 10 16.25L9.5 13.5L15.25 8.75C15.5 8.5 15.25 8.5 15 8.75L8.5 13L6.5 12.5C6.5 12.5 6 12.25 6 12C6 11.75 6.5 11.5 6.5 11.5L17 7.25C17.25 7.25 17.5 7.25 17.5 7.5Z' fill='#fff'/></svg><a href=\"https://t.me/ForsBotSupport\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-primary hover:underline font-medium\">@ForsBotSupport</a> on Telegram."
    },
    
    // Параметры
    parameters_updated: {
      RUS: "⚙️ <strong><u>ПАРАМЕТРЫ ОБНОВЛЕНЫ</u></strong><br><br>Сумма покупки: <strong>{buy_amount}</strong><br>Процент прибыли: <strong>{profit_percent}%</strong><br>Автопокупка при росте: <strong>{auto_buy_up_interval} сек</strong><br>Автопокупка при падении: <strong>{auto_buy_down_percent}%</strong><br>Комиссия: <strong>{fee_percent}%</strong>",
      ENG: "⚙️ <strong><u>PARAMETERS UPDATED</u></strong><br><br>Buy amount: <strong>{buy_amount}</strong><br>Profit percent: <strong>{profit_percent}%</strong><br>Auto buy up interval: <strong>{auto_buy_up_interval} sec</strong><br>Auto buy down percent: <strong>{auto_buy_down_percent}%</strong><br>Fee percent: <strong>{fee_percent}%</strong>"
    },
    
    // Разовые ордера
    order_buy_executed: {
      RUS: "🚀 <strong><u>КУПЛЕНО</u></strong><br><br>{amount} {base_currency} по {price} {quote_currency}<br>Потрачено: {total} {quote_currency}",
      ENG: "🚀 <strong><u>BOUGHT</u></strong><br><br>{amount} {base_currency} at {price} {quote_currency}<br>Spent: {total} {quote_currency}"
    },
    order_sell_executed: {
      RUS: "✅ <strong><u>ПРОДАНО</u></strong><br><br>{amount} {base_currency} по {price} {quote_currency}<br>Получено: {total} {quote_currency}",
      ENG: "✅ <strong><u>SOLD</u></strong><br><br>{amount} {base_currency} at {price} {quote_currency}<br>Received: {total} {quote_currency}"
    },
    
    // Автоторговля - управление
    autotrade_started: {
      RUS: "🚀 Автоторговля запущена.",
      ENG: "🚀 Auto-trading started."
    },
    autotrade_stopped: {
      RUS: "⛔️ Автоторговля остановлена!",
      ENG: "⛔️ Auto-trading stopped!"
    },
    autotrade_paused: {
      RUS: "⏸️ Автоторговля поставлена на паузу",
      ENG: "⏸️ Auto-trading paused"
    },
    autotrade_resumed: {
      RUS: "▶️ Автоторговля возобновлена",
      ENG: "▶️ Auto-trading resumed"
    },
    autotrade_already_running: {
      RUS: "⚠️ Автоторговля уже запущена",
      ENG: "⚠️ Auto-trading is already running"
    },
    
    // Автоторговля - исполнение сделок
    autotrade_buy_executed: {
      RUS: "🚀 <strong><u>КУПЛЕНО</u></strong><br>{amount} {base_currency} по {price} {quote_currency}<br>Потрачено: {spent} {quote_currency}<br><br><strong><u>ВЫСТАВЛЕНО</u></strong><br>{amount} {base_currency} по {sell_price} {quote_currency}<br>Планируемая прибыль: {profit} {quote_currency}",
      ENG: "🚀 <strong><u>BOUGHT</u></strong><br>{amount} {base_currency} at {price} {quote_currency}<br>Spent: {spent} {quote_currency}<br><br><strong><u>PLACED</u></strong><br>{amount} {base_currency} at {sell_price} {quote_currency}<br>Planned profit: {profit} {quote_currency}"
    },
    
    autotrade_sell_executed: {
      RUS: "✅ <strong><u>ПРОДАНО</u></strong><br>{amount} {base_currency} по {price} {quote_currency}<br>Получено: {received} {quote_currency}<br><br>💵 <strong><u>ПРИБЫЛЬ</u></strong><br>{profit} {quote_currency}",
      ENG: "✅ <strong><u>SOLD</u></strong><br>{amount} {base_currency} at {price} {quote_currency}<br>Received: {received} {quote_currency}<br><br>💵 <strong><u>PROFIT</u></strong><br>{profit} {quote_currency}"
    },
    
    // Автоторговля - уведомления
    autotrade_insufficient_funds: {
      RUS: "⚠️ <strong><u>НЕДОСТАТОЧНО СРЕДСТВ</u></strong><br><br>Недостаточно {quote_currency} для совершения покупки.<br>Доступный баланс должен быть на 1% больше суммы покупки (настраивается в команде Параметры).",
      ENG: "⚠️ <strong><u>INSUFFICIENT FUNDS</u></strong><br><br>Insufficient {quote_currency} for purchase.<br>Available balance must be 1% more than purchase amount (configured in Parameters command)."
    },
    
    autotrade_price_drop: {
      RUS: "❗️ <strong><u>УВЕДОМЛЕНИЕ</u></strong> ❗️<br>Цена {base_currency} упала на {percent}% от {last_price} {quote_currency}.",
      ENG: "❗️ <strong><u>NOTIFICATION</u></strong> ❗️<br>{base_currency} price dropped by {percent}% from {last_price} {quote_currency}."
    },
    
    autotrade_daily_stats: {
      RUS: "📊 <strong><u>СТАТИСТИКА ЗА ДЕНЬ</u></strong><br><br>Дата: <strong>{date}</strong><br>Количество сделок: <strong>{count}</strong><br>Прибыль: <strong>{profit} {quote_currency}</strong>",
      ENG: "📊 <strong><u>DAILY STATISTICS</u></strong><br><br>Date: <strong>{date}</strong><br>Number of trades: <strong>{count}</strong><br>Profit: <strong>{profit} {quote_currency}</strong>"
    }
  }
};

// Функция для форматирования сообщений с параметрами
// Функция для форматирования даты
export const formatDate = (dateString: string, language: 'RUS' | 'ENG' = 'RUS'): string => {
  const date = new Date(dateString);
  
  if (language === 'RUS') {
    const months = [
      'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
      'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  } else {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
  }
};

export const formatMessage = (
  templateKey: string, 
  params: Record<string, any> = {}, 
  language: 'RUS' | 'ENG' = 'RUS'
): string => {
  // Находим шаблон
  let template = '';
  
  // Ищем в ответах бота (user_commands закомментирован, так как не используется)
  if (templateKey in messageTemplates.bot_responses) {
    template = messageTemplates.bot_responses[templateKey as keyof typeof messageTemplates.bot_responses][language];
  }
  // Если не найден, возвращаем ключ как есть
  else {
    return templateKey;
  }

  // Обрабатываем специальные параметры
  const processedParams = { ...params };
  
  // Форматируем дату, если есть параметр end_date
  if (params.end_date && params.end_date !== 'unknown') {
    processedParams.formatted_date = formatDate(params.end_date, language);
  } else if (params.end_date === 'unknown') {
    processedParams.formatted_date = language === 'ENG' ? 'unknown' : 'неизвестно';
  }

  // Заменяем параметры в шаблоне
  let result = template.replace(/\{(\w+)\}/g, (match, key) => {
    return processedParams[key] !== undefined ? String(processedParams[key]) : match;
  });
  
  // Заменяем \n на <br> для HTML отображения
  result = result.replace(/\n/g, '<br>');
  
  return result;
};

// Типы для TypeScript
export type MessageTemplateKey = keyof typeof messageTemplates.bot_responses;
export type Language = 'RUS' | 'ENG'; 